import React, { PropsWithChildren } from 'react'
import { todistusTheme } from 'todistukset-ui/src/vtj/todistus-theme'
import { SuomifiThemeProvider } from 'suomifi-ui-components'
import { ThemeProvider } from 'styled-components'

/**
 * This theme provider wraps two theme providers together because the components from suomifi-ui-components
 * use the SuomifiThemeProvider and we also want to use the ThemeProvider provided by styled-components so we
 * can easily access variables from theme in styled components.
 * @param children
 * @constructor
 */
export default function TodistusThemeProvider({
  children,
}: PropsWithChildren): React.JSX.Element {
  return (
    <SuomifiThemeProvider theme={todistusTheme}>
      <ThemeProvider theme={todistusTheme}>{children}</ThemeProvider>
    </SuomifiThemeProvider>
  )
}
